
import { z } from "zod";

export const SocketSuggestedActionTypeValues = ["LIVE_CALL"] as const;
export const SocketSuggestedActionTypeSchema = z.enum(SocketSuggestedActionTypeValues);
export const SocketSuggestedActionType = SocketSuggestedActionTypeSchema.enum;
export type SocketSuggestedActionType = (typeof SocketSuggestedActionTypeValues)[number];
